import { createSelector } from 'reselect';
import { getClientCountries } from '../client';
import getCustomer from './getCustomer';

const getCustomerPassportForm = createSelector(
  state => getClientCountries(state),
  state => getCustomer(state),
  (countries, customer) => {
    if (!customer.loaded) {
      return {
        number: '',
        expiry_date: '',
        nationality: '',
        first_name: '',
        middle_names: '',
        last_name: '',
        country_code: {
          id: -1,
          name: '',
          code: '',
        },
        country_code_form: {
          value: -1,
          label: '',
          code: '',
        },
      };
    }
    const {
      number,
      expiry_date,
      nationality,
      first_name,
      middle_names,
      last_name,
      issue_country: passportCountry,
    } = customer?.passport || {};
    const countryByCode =
      countries.find(country => country.code === passportCountry.code) ||
      passportCountry;
    return {
      number,
      expiry_date: expiry_date ? new Date(expiry_date) : undefined,
      nationality,
      first_name,
      middle_names,
      last_name,
      country_code: countryByCode,
      country_code_form: {
        label: countryByCode?.name,
        value: countryByCode?.id,
        code: countryByCode?.code,
      },
    };
  },
);

export default getCustomerPassportForm;
